import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
`;

export const RowHeader = styled.div`
  display: grid;
  grid-template-columns: 1fr 170px;
  justify-content: flex-start;
  align-items: center;
  gap: 0.4rem;
  padding: 0.2rem 0;
  border-bottom: 1px solid ${({ theme }) => theme.grayDark};
`;

export const AreaSelectAll = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-end;

  .MuiFormControlLabel-root {
    margin: 0 0.3rem 0 0;
  }
`;
export const RowBody = styled.div`
  display: flex;
  flex-direction: column;
`;

export const RowPart = styled.div`
  display: grid;
  grid-template-columns: 100px 1fr 50px;
  justify-content: flex-start;
  align-items: center;
  gap: 0.4rem;
  padding: 0.2rem 0;
  border-bottom: 1px solid ${({ theme }) => theme.grayDark};
  cursor: pointer;
  transition: background-color 0.3s;

  &:hover {
    background-color: ${({ theme }) => theme.grayLight};
  }
`;
export const ImagePart = styled.img`
  width: 100%;
  max-width: 100px;
  height: 80px;
  object-fit: contain;
`;
export const AreaButtons = styled.div`
  display: flex;
  justify-content: center;
  gap: 1rem;
  margin: 1rem 0 0;

  & .MuiButtonBase-root {
    margin-left: 0px;
    padding: 8px 25px !important;
  }

  /* @media (max-width: ${({ theme }) => theme.breakpoints.mobile}) {
    > button  {padding: 0px 20px;}
  } */
`;

export const AreaReason = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.4rem;
  padding-top: 0.4rem;

  .MuiInputBase-root {
      border: 1px solid ${({ theme }) => theme.grayDark};
      padding-top: 0px;
      padding-bottom: 0px;
      padding-left: 2px;
    } 
`;

export const SkeletonRowPart = styled(RowPart)`
  margin: 0.4rem 0;
`;



